import chroma from "chroma-js";
import { theme } from "../stitches.config";
import { User } from "../types";

export const USER_COLORS = [
  "pink",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
] as const;

const OLD_USER_COLORS = {
  "rgba(254,215,160,1)": "orange",
  "rgba(254,196,210,1)": "pink",
  "rgba(255,183,180,1)": "red",
  "rgba(255,233,164,1)": "yellow",
  "rgba(192,241,200,1)": "green",
  "rgba(194,234,253,1)": "blue",
  "rgba(218,208,252,1)": "purple",
} as const;

export type UserColor = typeof USER_COLORS[number];
export type UserColorOld = keyof typeof OLD_USER_COLORS;

type Tone = 10 | 50 | 60 | 80 | 90 | 95;

export const FALLBACK_USER_COLOR = "yellow";

export function resolveUserColor(
  userColor: User["color"] | string | null | undefined
): UserColor {
  if (!userColor) {
    return FALLBACK_USER_COLOR;
  }

  userColor = OLD_USER_COLORS[userColor as UserColorOld] ?? userColor;

  if (!USER_COLORS.find((c) => c === userColor)) {
    return FALLBACK_USER_COLOR;
  }

  return userColor as UserColor;
}

/**
 * @param color a color token (i.e "pink") or old user color value
 * @return CSS color value
 */
export function colorValue(
  color: string | null | undefined,
  tone: Tone,
  alpha?: number
) {
  const c = resolveUserColor(color);
  const token = theme.colors[`${c}${tone}`];
  const cssColor = token.value;

  return alpha ? chroma(cssColor).alpha(alpha).css() : cssColor;
}
